/**
 * Route helpers for the standalone document editor and template editors (doc.edit context).
 */

/**
 * Returns a stable session key when the URL is a document or template editor surface, else null.
 * Used to start a fresh chat and skip auto-loading the previous conversation on those routes.
 *
 * @param {string} pathname - `location.pathname`
 * @param {string} search - `location.search`
 * @returns {string | null} e.g. `editor-doc:uuid` or `editor-template:uuid`
 */
export function getEditorSessionKey(pathname, search) {
  if (pathname === "/editor") {
    const id = new URLSearchParams(search).get("documentId");
    if (id) return `editor-doc:${id}`;
    return null;
  }
  const parts = pathname.split("/").filter(Boolean);
  if (parts[0] !== "templates") return null;
  if (parts[1] === "powerpoint-rich") {
    if (parts.length >= 4 && parts[3] === "edit" && parts[2] !== "new") {
      return `editor-template:${parts[2]}`;
    }
    return null;
  }
  if (parts.length >= 3 && parts[2] === "edit" && parts[1] !== "new") {
    return `editor-template:${parts[1]}`;
  }
  return null;
}
